var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"img",class:_vm.$style.image,attrs:{"data-src":_vm.src,"src":_vm.placeholder}})}
var staticRenderFns = []

export { render, staticRenderFns }